import { Experiment } from 'api-clients/monolith';
import { useState } from 'react';

import { LoginExperimentVariant } from 'features/LoginSelection/LoginSelection';

const loginCookie = 'loginExperimentShown';
const loginPreviouslyShown = () =>
  document.cookie.split(';').some(c => c.startsWith(loginCookie));

const variantOff = (variant?: string): boolean =>
  !variant || variant.toLocaleLowerCase() === 'control';

export type ExperimentReply = [LoginExperimentVariant | undefined, () => void];
/*
 * Consolidating most of the logic for the login UI experiment in a hook to make cleanup easier.
 * If the applicant refreshes the page we shouldn't show the experiment again so we flag it with a cookie.
 * We treat "control" or no value as not showing the experiment at all.
 */
export const useLoginExperiment = (
  experiments: Experiment[],
): ExperimentReply => {
  const [shownLogin, setShownLogin] = useState(false);

  const handleLogin = () => {
    const oneMonthSeconds = 2592000;
    document.cookie = `${loginCookie}=true;max-age=${oneMonthSeconds};sameSite=Lax;`;
    setShownLogin(true);
  };

  const variant = experiments.find(
    v => v.test_bucket_name === 'applicant-ui-v2-login-experiment',
  )?.test_bucket_value;

  if (loginPreviouslyShown() || shownLogin || variantOff(variant)) {
    return [undefined, handleLogin];
  }
  return [variant as LoginExperimentVariant, handleLogin];
};
